import React from "react";
import useCaregiver from "../hooks/useCaregiver";
import { isLoading } from "../Loading";
import { AppState } from "../system/AppState";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";

interface Props {
  appState: AppState;
  children: (caregiver: AppCaregiver) => React.ReactNode;
}

const WithCaregiver = (props: Props) => {
  const caregiver = useCaregiver(props.appState);

  return <>{isLoading(caregiver) ? null : props.children(caregiver)}</>;
};

export default WithCaregiver;
